import React from 'react';
import { NavLink } from 'react-router-dom';

var bgimg1 = require('./../../images/background/bbg.jpg');

class About2 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b80 bg-gray">
                        <div className="container">
                            <div className="section-content">
                                <div className="row">
                                    <div className="col-xl-5 col-lg-5 col-md-12 ">
                                        <div className="home-2-about bg-bottom-left bg-no-repeat bg-cover" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                        </div>
                                    </div>
                                    <div className="col-xl-7 col-lg-7 col-md-12">
                                        <div className="about-home-2">
                                            <h3 className="m-t0 sx-tilte">ACE, bureau d'études spécialisé en structures</h3>
                                            <p>offre son expertise à toutes les phases du cycle d'un projet de génie civil, débutant par sa conception initiale où nous identifions rigoureusement ses exigences et contraintes, jusqu'à sa réalisation complète. Notre priorité est d'atteindre la satisfaction totale de nos clients partenaires.</p>
                                            <p><strong>Pourquoi Nous Choisir :</strong>  <br/>
Dans un contexte où le domaine évolue constamment vers la numérisation et la complexité croissante, il est devenu essentiel de recourir à l'expertise d'un professionnel tel que ACE.<br/>
En effet, seul un bureau d'études doté d'une expertise avancée dans la modélisation, la conception et le suivi de vos projets sera en mesure de vous fournir les conseils les plus adaptés et les études de génie civil les plus efficaces.<br/>
Avec une expérience éprouvée dans le domaine du génie civil, nous offrons nos compétences techniques et notre savoir-faire pour vous fournir des services personnalisés.<br/>

<strong className='mt-10' >La stratégie d'ACE repose sur quatre axes fondamentaux :</strong> <br/>

1. Renforcer nos compétences de base.<br/>
2. Introduire de nouvelles prestations à forte valeur ajoutée.<br/>
3. Concevoir et mettre en œuvre de nouvelles solutions.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12	col-sm-12">
                                        <div className="large-title-info">
                                            <p>Avec notre expertise en génie civil et votre vision, nous façonnons un monde meilleur, où chaque construction est une étape vers un avenir plus prometteur et durable.</p>
                                            
                                        </div>
                                    </div>
                        </div>
                        
                    </div>
                   
            </>
        );
    }
};

export default About2;